<div class="modify-mobile-skeleton-mach-core">
  <!-- Mobile/Tablet: 375px - 991px -->
  <div class="flex flex-col gap-16">
    <!-- Default Fields + Checkboxes + Advanced Search -->
    <div class="flex flex-col gap-24">
      <!-- Default Fields Section -->
      <div class="flex flex-col gap-8">
        <!-- Field 1 (From/To) -->
        <div
          class="skeleton rounded-02 h-[74px] w-full"
          role="progressbar"
          aria-label="Loading departure and arrival cities"
        ></div>
        <!-- Field 2 (Departure Date) -->
        <div
          class="skeleton rounded-02 h-16 w-full"
          role="progressbar"
          aria-label="Loading departure date"
        ></div>
        <!-- Field 3 (Return Date) -->
        <div
          class="skeleton rounded-02 h-16 w-full"
          role="progressbar"
          aria-label="Loading return date"
        ></div>
        <!-- Field 4 (Passengers) -->
        <div
          class="skeleton rounded-02 h-16 w-full"
          role="progressbar"
          aria-label="Loading passenger count"
        ></div>
      </div>

      <!-- Checkboxes Section -->
      <div class="flex flex-col gap-16">
        <!-- Toggle 1 -->
        <div class="flex items-center justify-between">
          <div
            class="skeleton rounded-01 h-6 w-[126px]"
            role="progressbar"
            aria-label="Loading label"
          ></div>
          <div
            class="skeleton rounded-01 h-[25px] w-[45px]"
            role="progressbar"
            aria-label="Loading toggle"
          ></div>
        </div>

        <!-- Toggle 2 -->
        <div class="flex items-center justify-between">
          <div
            class="skeleton rounded-01 h-6 w-[163px]"
            role="progressbar"
            aria-label="Loading label"
          ></div>
          <div
            class="skeleton rounded-01 h-[25px] w-[45px]"
            role="progressbar"
            aria-label="Loading toggle"
          ></div>
        </div>

        <!-- Toggle 3 -->
        <div class="flex items-center justify-between">
          <div
            class="skeleton rounded-01 h-6 w-[146px]"
            role="progressbar"
            aria-label="Loading label"
          ></div>
          <div
            class="skeleton rounded-01 h-[25px] w-[45px]"
            role="progressbar"
            aria-label="Loading toggle"
          ></div>
        </div>

        <!-- Toggle 4 -->
        <div class="flex items-center justify-between">
          <div
            class="skeleton rounded-01 h-6 w-[196px]"
            role="progressbar"
            aria-label="Loading label"
          ></div>
          <div
            class="skeleton rounded-01 h-[25px] w-[45px]"
            role="progressbar"
            aria-label="Loading toggle"
          ></div>
        </div>
      </div>

      <!-- Advanced Search Section -->
      <div
        class="flex items-center justify-between border-t border-[var(--stroke-01,#dfe0e6)] pt-12 pb-8"
      >
        <div
          class="skeleton rounded-01 h-[18px] w-[135px]"
          role="progressbar"
          aria-label="Loading advanced search"
        ></div>
        <div
          class="skeleton rounded-01 size-[18px]"
          role="progressbar"
          aria-label="Loading expand icon"
        ></div>
      </div>
    </div>

    <!-- Advanced Search Expanded Content -->
    <div class="flex flex-col gap-16 pb-8">
      <!-- Toggle -->
      <div class="flex items-center justify-between pb-8">
        <div
          class="skeleton rounded-01 h-[22px] w-[182px]"
          role="progressbar"
          aria-label="Loading label"
        ></div>
        <div
          class="skeleton rounded-01 h-[25px] w-[45px]"
          role="progressbar"
          aria-label="Loading toggle"
        ></div>
      </div>

      <!-- Dropdown Field 1 -->
      <div
        class="skeleton rounded-02 h-16 w-full"
        role="progressbar"
        aria-label="Loading dropdown"
      ></div>

      <!-- Label -->
      <div
        class="skeleton rounded-01 h-[10px] w-[69px]"
        role="progressbar"
        aria-label="Loading label"
      ></div>

      <!-- Dropdown Field 2 -->
      <div
        class="skeleton rounded-02 h-16 w-full"
        role="progressbar"
        aria-label="Loading dropdown"
      ></div>

      <!-- Links -->
      <div
        class="skeleton rounded-01 h-[10px] w-[166px]"
        role="progressbar"
        aria-label="Loading link"
      ></div>
      <div
        class="skeleton rounded-01 h-[10px] w-[124px]"
        role="progressbar"
        aria-label="Loading link"
      ></div>
    </div>

    <!-- Search Button -->
    <div
      class="skeleton rounded-02 h-[52px] w-full"
      role="progressbar"
      aria-label="Loading search button"
    ></div>
  </div>
</div>
